
import { Http, Headers } from '@angular/http';
import { Storage } from '@ionic/storage';
import { Injector } from '@angular/core';
import { ModalController, AlertController, PopoverController, Platform, LoadingController } from 'ionic-angular';
import { HTTP } from '@ionic-native/http/ngx';
//import { HTTP } from '@ionic-native/http';
//import { SQLite } from '@ionic-native/sqlite/ngx';
//import { DomSanitizer } from '../../node_modules/@angular/platform-browser';


export abstract class Util {
    urlserver = '';
    keysitecaptcha = '';
    secretkeycaptcha = '';
    urldownloadapp = '';
    etic: any = {
        en: {

            errorinternet: 'Errore connessione internet',
            errorlogin: 'Nome Utente o password errate',

        }
    };

    httpobj: any;
    mylatitude: any;
    mylongitude: any;
    iframepecserver: any;
    public storage: Storage;
    public http: any;
    public modalCtrl: ModalController;
    public alertCtrl: AlertController;
    public popoverCtrl: PopoverController;
    public plt: Platform;
    public loadingCtrl: LoadingController = null;
    //public sqlite: SQLite;
    //public sanitizer: DomSanitizer;


    constructor(injector: Injector, loading: LoadingController) {
        this.plt = injector.get(Platform);
        this.loadingCtrl = loading;
        /*if ((this.plt.is('ios') || this.plt.is('android')) && !this.plt.is('mobileweb'))
            this.http = injector.get(HTTP);
        else*/
        this.http = injector.get(Http);

        this.storage = injector.get(Storage);
        this.modalCtrl = injector.get(ModalController);
        this.alertCtrl = injector.get(AlertController);
        this.popoverCtrl = injector.get(PopoverController);
        //this.sqlite = injector.get(SQLite);

        //  this.sanitizer = injector.get(DomSanitizer);
    }

    static getUrlServer() {
        //console.log("AAA: getUrlServer");
        return "https://www.bevandepistilli.com/controller.php?";
        //return "http://localhost/pistilli/controller.php?";
    }


    presentPopover(myEvent, PopoverPage, testo, num?) {

        return new Promise((resolve, reject) => {
            var postop = (this.plt.height() / 2) - 200;
            let popover = this.popoverCtrl.create(PopoverPage, { testo: testo, num: num });
            let ev = {
                target: {
                    getBoundingClientRect: () => {
                        return {
                            top: postop
                        };
                    }
                }
            };
            popover.present({
                ev: ev
            });
            /*popover.present({
                ev: myEvent
            });*/
            popover.onDidDismiss((data) => {
                resolve(data);
            })
        })

    }
    /*PostRequest(link, params, http) {
        return new Promise((resolve, reject) => {
            var headers = new Headers();
            headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            http.post(link, params, { headers: headers })
                .subscribe(data => {
                    if (data['status'] == 200) {
                        var returned = data['_body'];
                        resolve(JSON.parse(returned)); 
                    }
                    else
                        reject('Errore server' + data['_body']);

                }, error => {
                    reject('Errore server');
                });
        });

    }*/

    private manageResponseError(response: any, showAlertError: boolean) {

        if (showAlertError) {

            if (response.errors != null) {
                this.showBasicAlert('Errore', response.errors);
            }
            else if (response != null) {
                var e = response['_body'];
                console.log(e);
                this.showBasicAlert('Errore', JSON.parse(e).errors);
            }
            else {
                this.showBasicAlert('Errore', this.etic.en.errorinternet);
            }
        }



    }

    private manageResponse(response: string, error: string, loading: any, showAlertError: boolean, resolve: any, reject: any) {

        if (loading != null) {
            loading.dismiss();
        }

        if (response != null) {

            try {
                
                if (response == null || response == '') {
                    this.manageResponseError(response, showAlertError);
                    reject("Errore");
                } else {
                    var responseObj = JSON.parse('' + response + '');
                    if (responseObj.response == 0) {
                        resolve(responseObj.data);
                    } else {
                        this.manageResponseError(responseObj, showAlertError);
                        reject(responseObj);
                    }
                }
            
            }
            catch (e) {
                this.manageResponseError(e, showAlertError);
                reject(e);
            }
        } else {
            this.manageResponseError(error, showAlertError);
            reject(error);
        }

    }

    GetRequest(service, id, showLoading: boolean = true, showAlertError: boolean = true) {
        var loading = null;
        if (showLoading && this.loadingCtrl != null) {
            loading = this.loadingCtrl.create({
                content: 'Caricamento...'
            });
            loading.present();
        }


        /*if ((this.plt.is('ios') || this.plt.is('android')) && !this.plt.is('mobileweb'))
            return new Promise((resolve, reject) => {
                this.storage.get('user').then(user => {
                    console.log('token:', user.token);
                    if (user != null && user != undefined && user != '')
                        this.http.setHeader('Authorization', 'Bearer ' + user.token);
                    this.http.setDataSerializer('json');
                    this.http.get(service, {}, {})
                        .then(data => {
                            this.manageResponse(data['data'], null, loading, showAlertError, resolve, reject);
                        })
                        .catch(error => {
                            console.log(JSON.stringify(error));
                            this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                        });
                });
            });
        else*/
        return new Promise((resolve, reject) => {
            let headers = new Headers();
            headers.append("Content-Type", "application/json");
            this.storage.get('user').then(user => {

                if (user != null && user.token != undefined) {
                    headers.append('Authorization', 'Bearer ' + user.token);
                }

                this.http.get(service, { headers: headers })
                    .subscribe(res => {
                        this.manageResponse(res['_body'], null, loading, showAlertError, resolve, reject);
                    },
                        error => {
                            this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                        });
            });
        });
    }

    PostRequest(service, params, showLoading: boolean = true, showAlertError: boolean = true) {

        var loading = null;
        if (showLoading && this.loadingCtrl != null) {
            loading = this.loadingCtrl.create({
                content: 'Caricamento...'
            });
            loading.present();
        }
        /*
                if ((this.plt.is('ios') || this.plt.is('android')) && !this.plt.is('mobileweb'))
                    return new Promise((resolve, reject) => {
                        this.storage.get('user').then(user => {
                            //this.http.setHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                            //this.http.setHeader('Accept', 'application/json');
        
                            if (user != null && user != undefined && user != '')
                                this.http.setHeader('Authorization', 'Bearer ' + user.token);
                            
                            this.http.setDataSerializer('json');
                            this.http.post(this.urlserver + service + "/" + id, params, {})
        
                                .then(data => {
                                    this.manageResponse(data['data'], null, loading, showAlertError, resolve, reject);
                                })
                                .catch(error => {
                                    this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                                });
                        });
                    });
                else*/
        return new Promise((resolve, reject) => {
            let headers = new Headers();
            headers.append("Content-Type", "application/json");
            this.storage.get('user').then(user => {

                if (user != null && user.token != undefined) {
                    headers.append('Authorization', 'Bearer ' + user.token);
                }
                this.http.post(service, params, { headers: headers })
                    .subscribe(res => {
                        this.manageResponse(res['_body'], null, loading, showAlertError, resolve, reject);
                    },
                        error => {
                            this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                        });

            })
        });
    }

    PutRequest(service, id, params, showLoading: boolean = true, showAlertError: boolean = true) {

        var loading = null;
        if (showLoading && this.loadingCtrl != null) {
            loading = this.loadingCtrl.create({
                content: 'Caricamento...'
            });
            loading.present();
        }

        if ((this.plt.is('ios') || this.plt.is('android')) && !this.plt.is('mobileweb'))
            return new Promise((resolve, reject) => {
                this.storage.get('user').then(user => {
                    //this.http.setHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                    //this.http.setHeader('Accept', 'application/json');

                    if (user != null && user != undefined && user != '')
                        this.http.setHeader('Authorization', 'Bearer ' + user.token);

                    this.http.setDataSerializer('json');
                    this.http.put(this.urlserver + service + "/" + id, params, {})

                        .then(data => {
                            this.manageResponse(data['data'], null, loading, showAlertError, resolve, reject);
                        })
                        .catch(error => {
                            this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                        });
                });
            });
        else
            return new Promise((resolve, reject) => {
                let headers = new Headers();
                headers.append("Content-Type", "application/json");
                this.storage.get('user').then(user => {
                    console.log(user);
                    if (user != null && user.token != undefined) {
                        headers.append('Authorization', 'Bearer ' + user.token);
                    }
                    this.http.put(this.urlserver + service + "/" + id, params, { headers: headers })
                        .subscribe(res => {
                            this.manageResponse(res['_body'], null, loading, showAlertError, resolve, reject);
                        },
                            error => {
                                this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                            });

                })
            });
    }
    PutRequest_old(service, id, params, showLoading: boolean = true, showAlertError: boolean = true) {

        var loading = null;
        if (showLoading && this.loadingCtrl != null) {
            loading = this.loadingCtrl.create({
                content: 'Caricamento...'
            });
            loading.present();
        }

        /*if (this.plt.is('ios') || this.plt.is('android'))
            return new Promise((resolve, reject) => {
                this.storage.get('user').then(user => {
                    //this.http.setHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                    //this.http.setHeader('Accept', 'application/json');

                    if (user != null && user != undefined && user != '')
                        this.http.setHeader('Authorization', 'Bearer ' + user.user.token);
                    this.http.setDataSerializer('json');
                    this.http.put(this.urlserver + service + "/" + id, params, {})
                        .then(data => {
                            this.manageResponse(data['data'], null, loading, showAlertError, resolve, reject);
                        })
                        .catch(error => {
                            this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                        });
                });
            });
        else*/
        return new Promise((resolve, reject) => {
            let headers = new Headers();
            headers.append("Content-Type", "application/json");
            this.storage.get('user').then(user => {

                if (user != null && user.user.token != undefined) {
                    headers.append('Authorization', 'Bearer ' + user.user.token);
                }
                this.http.put(this.urlserver + service + "/" + id, params, { headers: headers })
                    .subscribe(res => {
                        this.manageResponse(res['_body'], null, loading, showAlertError, resolve, reject);
                    },
                        error => {
                            this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                        });
            });
        });
    }
    DeleteRequest(service, id, showLoading: boolean = true, showAlertError: boolean = true) {

        var loading = null;
        if (showLoading && this.loadingCtrl != null) {
            loading = this.loadingCtrl.create({
                content: 'Caricamento...'
            });
            loading.present();
        }


        /*if (this.plt.is('ios') || this.plt.is('android'))
            return new Promise((resolve, reject) => {
                this.storage.get('user').then(user => {
                    //this.http.setHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                    //this.http.setHeader('Accept', 'application/json');

                    if (user != null && user != undefined && user != '')
                        this.http.setHeader('Authorization', 'Bearer ' + user.user.token);
                    this.http.setDataSerializer('json');
                    this.http.delete(this.urlserver + service + "/" + id, {}, {})
                        .then(data => {
                            this.manageResponse(data['data'], null, loading, showAlertError, resolve, reject);
                        })
                        .catch(error => {
                            this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                        });
                });
            });
        else*/
        return new Promise((resolve, reject) => {
            let headers = new Headers();
            headers.append("Content-Type", "application/json");
            this.storage.get('user').then(user => {

                if (user != null && user.user.token != undefined) {
                    headers.append('Authorization', 'Bearer ' + user.user.token);
                }
                this.http.delete(this.urlserver + service + "/" + id, { headers: headers })
                    .subscribe(res => {
                        this.manageResponse(res['_body'], null, loading, showAlertError, resolve, reject);
                    },
                        error => {
                            this.manageResponse(null, error, loading, showAlertError, resolve, reject);
                        });
            });
        });
    }

    showBasicAlert(title, subtitle) {
        let alert = this.alertCtrl.create({
            title: title,
            subTitle: subtitle,
            buttons: [{
                text: 'OK',
                role: 'cancel'
            }]
        });
        alert.present();
    }

    presentAlertPrompt() {
        let alert = this.alertCtrl.create({
            title: 'Login',
            inputs: [
                {
                    name: 'username',
                    placeholder: 'Username'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: data => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Login',
                    handler: data => {
                        console.log('aaa');
                    }
                }
            ]
        });
        alert.present();
    }


    PostRequest_(link, params, loadingCtrl, storage, platform) {
        return new Promise((resolve, reject) => {
            var http: any = this.http;
            storage.get('mycity').then((mycity) => {
                console.log(mycity);
                if (mycity != null && mycity.hasOwnProperty('nome_IT')) {
                    link = link + '&city=' + mycity.nome_IT;
                    params.city = mycity.nome_IT;
                }
                let loading = loadingCtrl.create({
                    content: 'Caricamento...'
                });
                loading.present();

                if (platform.is('ios') || platform.is('android')) {
                    http.setHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

                    http.setHeader('Accept', 'application/json');
                    console.log('sono qui 0');
                    http.post(link, params, {})
                        .then(data => {
                            console.log('******');
                            console.log(data);
                            console.log('******122222');
                            if (data['status'] == 200) {
                                var returned = data['data'];
                                try {

                                    resolve(JSON.parse(returned));
                                } catch (e) {
                                    reject('Errore JSON');
                                }
                                if (loading != null) loading.dismiss();
                            }
                            /*else if(data['status'] == 401){
    
                            }*/
                            else {
                                reject('Non sei connesso a Internet');
                                console.log('sono qui 1');
                                if (loading != null) loading.dismiss();
                            }


                        }, error => {
                            console.log('sono qui 2');
                            reject('Non sei connesso a Internet');
                            if (loading != null) loading.dismiss();
                        });
                }
                else {
                    let _params = new URLSearchParams();
                    for (let key in params) {
                        _params.set(key, params[key])
                    }
                    var headers = new Headers();
                    headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

                    headers.append('Accept', 'application/json');
                    http.post(link, _params.toString(), { headers: headers })
                        .subscribe(data => {
                            console.log(data);
                            if (data['status'] == 200) {
                                var returned = data['_body'];
                                try {
                                    resolve(JSON.parse(returned));
                                } catch (e) {
                                    reject('Errore JSON');
                                }
                                if (loading != null) loading.dismiss();
                            }
                            else {
                                reject('Errore server 3' + data['_body']);
                                if (loading != null) loading.dismiss();
                            }


                        }, error => {
                            reject('Errore server 4 : ' + link + ' header: ' + JSON.stringify(headers) + ' params: ' + _params.toString());
                            if (loading != null) loading.dismiss();
                        });
                }

            });
        });
        //});

    }


    openModal(ModalPage, params) {
        return new Promise((resolve, reject) => {
            let profileModal = this.modalCtrl.create(ModalPage, params);
            profileModal.onDidDismiss(data => {
                resolve(data);
            });
            profileModal.present();
        });
    }

    distance(lat1, lon1, lat2, lon2) {
        var radlat1 = Math.PI * lat1 / 180
        var radlat2 = Math.PI * lat2 / 180
        var theta = lon1 - lon2
        var radtheta = Math.PI * theta / 180
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        dist = Math.acos(dist)
        dist = dist * 180 / Math.PI
        dist = dist * 60 * 1.1515
        //if (unit=="K") { dist = dist * 1.609344 } km
        //if (unit=="N") { dist = dist * 0.8684 }miglia nautiche
        dist = dist * 1.609344
        return dist;
    }
    arrotondaNumero(numero, nDecimali) {
        // arrotondo il numero con le cifre decimali indicate
        var numero_arrotondato = Math.round(numero * Math.pow(10, nDecimali)) / Math.pow(10, nDecimali);
        // ritorno come risultato il numero arrotondato
        return numero_arrotondato;
    }
    showAlert(title, subtitle, alertCtrl) {
        let alert = alertCtrl.create({
            title: title,
            subTitle: subtitle,
            buttons: ['OK']
        });
        alert.present();
    }
    open_in_app_browser(pdfpath, platform, iab) {

        /*if (platform.is('ios') || platform.is('android')) {

            console.log(pdfpath);
            if (platform.is('android')) {
                let iabobj = iab.create(pdfpath, '_blank', "location=yes");
                iabobj.show();
            }
            else {
                let iabobj = iab.create(pdfpath, '_blank', "location=yes,closebuttoncaption=Chiudi,enableViewportScale=yes");
                iabobj.show();
            }

        }
        else*/
        window.open(pdfpath, '_blank');

    }
    clone(obj) {
        let copy = (JSON.parse(JSON.stringify(obj)));
        return copy;
    }
}



// WEBPACK FOOTER //
// ./src/app/util.ts